// Standardized empty-state placeholder used across pages and panels.
// Lucide icon + title + description, centered, muted.

import type { LucideIcon } from 'lucide-react';

interface Props {
  icon: LucideIcon;
  title: string;
  description?: string;
}

export function EmptyState({ icon: Icon, title, description }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <Icon className="mb-2 h-8 w-8 text-muted-foreground/40" />
      <div className="text-sm font-medium text-muted-foreground">{title}</div>
      {description && (
        <div className="text-xs text-muted-foreground">{description}</div>
      )}
    </div>
  );
}
